import { Home, AlertTriangle, ShieldCheck } from "lucide-react";
import { Button } from "@/components/ui/button";
import { DirectionsButton } from "@/components/route/DirectionsDialog";

const Row = ({ label, value, testid }) => (
  <div className="flex justify-between gap-3 py-1.5 border-b border-slate-100 last:border-0 text-sm">
    <span className="text-slate-500">{label}</span>
    <span className="font-semibold text-slate-900 text-right" data-testid={testid}>{value || "-"}</span>
  </div>
);

export const parcelLabel = (p) => `${p.il} / ${p.ilce} / ${p.mahalle} · Ada ${p.ada} Parsel ${p.parsel}`;

export function ParcelInfoCard({ result, canConvert, onConvert }) {
  const { parcel: p, duplicate } = result;
  return (
    <div className="space-y-3" data-testid="parcel-info-card">
      <div className="flex items-center gap-2 text-xs text-emerald-800 bg-emerald-50 border border-emerald-200 rounded-lg px-3 py-2">
        <ShieldCheck className="w-4 h-4 shrink-0" />Veri kaynağı: Tapu ve Kadastro Genel Müdürlüğü (TKGM)
      </div>
      <div>
        <Row label="İl" value={p.il} testid="parcel-il" />
        <Row label="İlçe" value={p.ilce} testid="parcel-ilce" />
        <Row label="Mahalle" value={p.mahalle} testid="parcel-mahalle" />
        <Row label="Ada / Parsel" value={`${p.ada} / ${p.parsel}`} testid="parcel-ada-parsel" />
        <Row label="Yüzölçümü" value={p.alan_text ? `${p.alan_text} m²` : null} testid="parcel-alan" />
        <Row label="Nitelik" value={p.nitelik} testid="parcel-nitelik" />
        <Row label="Mevkii" value={p.mevkii} />
        <Row label="Pafta" value={p.pafta} />
        <Row label="Zemin" value={p.zemin} />
      </div>
      {duplicate && (
        <div className="flex gap-2 text-xs text-amber-800 bg-amber-50 border border-amber-200 rounded-lg px-3 py-2" data-testid="parcel-duplicate-warning">
          <AlertTriangle className="w-4 h-4 shrink-0" />Bu parsel zaten portföyünüzde kayıtlı: <b>{duplicate.title}</b>
        </div>
      )}
      <div className="grid gap-2">
        {canConvert ? (
          <Button data-testid="parcel-convert-btn" disabled={!!duplicate} onClick={onConvert} className="bg-emerald-700 hover:bg-emerald-800"><Home className="w-4 h-4 mr-2" />Portföye Dönüştür</Button>
        ) : (
          <div className="text-xs text-slate-500" data-testid="parcel-convert-unavailable">Portföye dönüştürme yalnızca ofis hesaplarında kullanılabilir.</div>
        )}
        <DirectionsButton testid="parcel-directions-btn" target={{ lat: p.lat, lng: p.lng, geometry: p.geometry, label: parcelLabel(p) }} />
      </div>
    </div>
  );
}
